import { Component } from "@theme/component";

/**
 * @extends {Component<{requestType: HTMLSelectElement, country: HTMLSelectElement, province: HTMLSelectElement, orderField: HTMLElement, productField: HTMLElement}>}
 */
class LNContactFormComponent extends Component {
  requiredRefs = [
    "requestType",
    "country",
    "province",
    "orderField",
    "productField",
  ];

  #initialized = false;

  connectedCallback() {
    super.connectedCallback();

    if (!this.#initialized) {
      const { country, province } = this.refs;
      if (country.dataset.defaultCountry)
        country.value = country.dataset.defaultCountry;
      this.updateRequestFields();
      this.updateProvinces();
      if (province.dataset.defaultProvince && !province.disabled)
        province.value = province.dataset.defaultProvince;
      this.#initialized = true;
    } else {
      this.updateRequestFields();
    }

    window.addEventListener("pageshow", this.#onPageShow);
  }

  disconnectedCallback() {
    window.removeEventListener("pageshow", this.#onPageShow);
    super.disconnectedCallback();
  }

  updateRequestFields() {
    const { requestType, orderField, productField } = this.refs;
    const showOrder =
      requestType.value === "order" || requestType.value === "support";
    const showProduct = requestType.value === "product";
    for (const { wrapper, visible } of [
      { wrapper: orderField, visible: showOrder },
      { wrapper: productField, visible: showProduct },
    ]) {
      wrapper.hidden = !visible;
      const input = wrapper.querySelector("input");
      if (input) input.required = visible;
    }
  }

  updateProvinces() {
    const { country, province } = this.refs;
    const data = country.selectedOptions[0]?.dataset.provinces;
    let provinces = [];
    if (data) {
      try {
        const parsed = JSON.parse(data);
        if (Array.isArray(parsed)) provinces = parsed;
      } catch {
        provinces = [];
      }
    }
    province.replaceChildren();
    for (const entry of provinces) {
      if (!Array.isArray(entry) || typeof entry[0] !== "string") continue;
      const option = document.createElement("option");
      option.value = entry[0];
      option.textContent = entry[0];
      province.append(option);
    }
    province.disabled = province.options.length === 0;
  }

  #onPageShow = () => this.updateRequestFields();
}

if (!customElements.get("ln-contact-form-component")) {
  customElements.define("ln-contact-form-component", LNContactFormComponent);
}
